import { apiSlice } from "../../app/api/apiSlice";

export const orderApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 🧾 SYSTEM MASTER LOG: Admin views global checkouts
    getAllSystemOrdersForAdmin: builder.query({
      query: (statusFilter) => ({
        url: "/orders/admin/orders",
        method: "GET",
        params: statusFilter ? { status: statusFilter } : {},
      }),
      providesTags: ["Order"],
    }),

    // ADMIN: Approve a paid order for future fulfillment.
    approveOrderByAdmin: builder.mutation({
      query: (orderId) => ({
        url: `/orders/admin/orders/${orderId}/approve`,
        method: "PUT",
      }),
      invalidatesTags: ["Order"],
    }),

    // 🔄 ADMIN ORDER STATUS TOGGLER: Change parameters between succeeded, shipped, or delivered
    updateOrderStatusByAdmin: builder.mutation({
      query: ({ orderId, status }) => ({
        url: `/orders/admin/orders/${orderId}/status`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: ["Order"],
    }),

    // 👤 PROFILE PANEL FEED: Secure history records loader (No argument parameter tracking strings required!)
    getLoggedInUserOrderHistory: builder.query({
      query: () => "/orders/user/orders", // 🔥 Look ma, no parameters string variables needed!
      providesTags: ["Order"],
    }),

    // Inside your orderApiSlice.js endpoints definition mapping:
    cancelActiveOrder: builder.mutation({
      query: (orderId) => ({
        url: `/orders/user/orders/${orderId}/cancel`,
        method: "PUT",
      }),
      invalidatesTags: ["Order"],
    }),

    returnDeliveredOrder: builder.mutation({
      query: (orderId) => ({
        url: `/orders/user/orders/${orderId}/return`,
        method: "PUT",
      }),
      invalidatesTags: ["Order"],
    }),
  }),
});

export const {
  useApproveOrderByAdminMutation,
  useGetAllSystemOrdersForAdminQuery,
  useUpdateOrderStatusByAdminMutation,
  useGetLoggedInUserOrderHistoryQuery,
  useCancelActiveOrderMutation, // ➕ Exported!
  useReturnDeliveredOrderMutation,
} = orderApiSlice;
